<template>
  <div>
    <Modal
      v-model="serverSelectModal"
      title="选择服务器"
      width="1000">
      <div style="text-align: left">
        <RadioGroup v-model="selectType">
          <Radio label="server">常规选择</Radio>
          <Radio label="group">从分组选择</Radio>
        </RadioGroup>
      </div>
      <ul v-show="selectType === 'group'" id="execServerGroupZTree" class="ztree"></ul>
      <Divider />
      <div>
        <span>已选服务器(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptyServer" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'hostname_' + index" @on-close="removeServer('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="85" ref="searchServerForm" :model="searchServerForm">
        <FormItem label="设备名">
          <Input v-model="searchServerForm.name" @on-enter="getServers()" placeholder="过滤设备名"/>
        </FormItem>
        <FormItem label="设备管理地址">
          <Input v-model="searchServerForm.asset_ip" @on-enter="getServers()" placeholder="过滤公网IP"/>
        </FormItem>
        <FormItem label="设备类型">
          <Select v-model="searchServerForm.asset_type" style="min-width:100px" clearable>
            <Option v-for="item in assetTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getServers()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetServerSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="serverError" type="warning" show-icon>获取服务器列表失败</Alert>
      <div v-else>
        <!-- <Alert show-icon>提示！无法选择未填写设备名的服务器！</Alert> -->
        <Table
          ref="serverTable"
          :loading="serverTableLoading"
          :data="server.data"
          size="small"
          :columns="server.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ server.data.length }} 条记录，总共 {{ server.count }} 条记录
          </div>
          <div style="float: right;">
            <page :total="server.count" :current="server.page" :page-size="server.size" @on-change="getServers"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectServerOk">确定</Button>
        <Button @click="serverSelectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getNetworkServerGroup, getNetworkServer, getNetworkAllServer } from '@/api/network'
import { getJsonLength } from '../ops-center/scriptTools'
export default {
  name: 'select-asset',
  data () {
    return {
      assetTypeList: [
        // {
        //   value: 0,
        //   label: '软件'
        // },
        // {
        //   value: 1,
        //   label: '硬件'
        // },
        {
          value: 2,
          label: '交换设备'
        },
        {
          value: 3,
          label: '路由设备'
        },
        {
          value: 4,
          label: '安全设备'
        }
        // {
        //   value: 9,
        //   label: '未知'
        // }
      ],
      // 选择目标服务器
      serverError: false,
      serverSelectModal: false,
      selected: [],
      selectType: 'server',
      searchServerForm: {
        name: '',
        asset_type: '',
        asset_ip: ''
      },
      assetParams: {},
      server: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.asset_ip) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.asset_ip) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.server.data[params.index].checkBox = e
                      if (e) {
                        console.log(params.row)
                        if (this.selectRow.indexOf(params.row.asset_ip) < 0) {
                          this.selectRow.push(params.row.asset_ip)
                          this.selectServerIds[params.row.asset_ip] = params.row.id
                        }
                      } else {
                        this.removeServer(null, params.row.asset_ip)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            minWidth: 160,
            title: '设备名称',
            tooltip: true,
            align: 'center',
            key: 'name',
            render: (h, params) => {
              if (params.row.name) {
                return h('div', params.row.name)
              }
            }
          },
          {
            minWidth: 110,
            title: '设备管理地址',
            align: 'center',
            key: 'asset_ip'
          },
          {
            minWidth: 100,
            title: '设备类型',
            align: 'center',
            key: 'os',
            render: (h, params) => {
              let k = { 0: '软件', 1: '硬件', 2: '交换设备', 3: '路由设备', 4: '安全设备', 9: '未知' }
              return h('div', k[params.row.asset_type])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5
      },
      serverTableLoading: false,
      selectRow: [],
      selectServerIds: {},
      endSelectServer: {},
      endSelectServerLength: 0,
      id: '',
      // 服务器组
      zTreeSetting: {
        view: {
          selectedMulti: false
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }]
    }
  },
  methods: {
    // 打开服务器选择Modal
    openSelectServerModal (assetParams = {}, selectedServer = {}, id = '') {
      this.id = id
      this.assetParams = assetParams
      this.getServers()
      this.getServerGroup()
      this.selectServerIds = {}
      this.selectRow = []
      for (let name in selectedServer) {
        if (selectedServer[name]) {
          this.selectRow.push(name)
          this.selectServerIds[name] = selectedServer[name]
        }
      }
      this.serverSelectModal = true
    },
    // 获取服务器分组列表
    getServerGroup () {
      this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }]
      getNetworkServerGroup().then(res => {
        this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取服务器分组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // zTree初始化
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#execServerGroupZTree'), this.zTreeSetting, this.zNodes)
    },
    // 点击服务器列表
    zTreeOnClick (event, treeId, treeNode) {
      let idIn = ''
      if (treeNode.id !== 0) {
        let childNodes = this.getChildNodes(treeNode)
        if (childNodes) {
          idIn = childNodes
        } else {
          idIn = 99999999
        }
      }
      this.emptyServer()
      getNetworkAllServer({ id__in: idIn }).then(res => {
        let result = res.data
        for (let i in result) {
          if (result[i].asset_ip) {
            this.selectRow.push(result[i].asset_ip)
            this.selectServerIds[result[i].asset_ip] = result[i].id
          }
        }
        this.getServers(this.server.page)
      })
    },
    // 获取子Nodes
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          console.log(childNodes[i])
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      console.log(nodes.join(','))
      return nodes.join(',')
    },
    // 获取服务器列表和存活状态
    getServers (value = 1) {
      this.server.page = value
      this.serverTableLoading = true
      this.searchServerForm['size'] = this.server.size
      this.searchServerForm['page'] = this.server.page
      for (let p in this.assetParams) {
        this.searchServerForm[p] = this.assetParams[p]
      }
      this.serverError = false
      getNetworkServer(this.searchServerForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.server.count = result.count
        this.server.data = tableData
        this.serverTableLoading = false
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取设备列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 重置搜索表单
    resetServerSearchForm () {
      this.searchServerForm = {
        name: '',
        asset_type: '',
        asset_ip: ''
      }
      this.getServers()
    },
    // 移除选中的服务器
    removeServer (event, assetIp) {
      if (event) {
        for (let i in this.server.data) {
          if (this.server.data[i].asset_ip === assetIp) {
            this.server.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(assetIp)
      this.selectRow.splice(index, 1)
      this.selectServerIds[assetIp] = null
    },
    // 清空选中的服务器
    emptyServer () {
      this.selectServerIds = {}
      for (let i in this.server.data) {
        this.server.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择服务器完成
    selectServerOk () {
      this.endSelectServer = {}
      for (let name in this.selectServerIds) {
        if (this.selectServerIds[name]) {
          this.endSelectServer[name] = this.selectServerIds[name]
        }
      }
      this.selectServerIds = {}
      this.selectRow = []
      this.endSelectServerLength = getJsonLength(this.endSelectServer)
      this.serverSelectModal = false
      this.$emit('selectServerComplete', this.endSelectServer, this.endSelectServerLength, this.id)
    }
  }
}
</script>

<style>
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
